import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-static-about',
  templateUrl: './static-about.component.html',
  styleUrls: ['./static-about.component.css']
})
export class StaticAboutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /srv/scratch/old-home/dyall/trinity/trinity-frontend-master/src/app/static-about/static-about.component.ts